import React from 'react';
import { useState ,useEffect, useMemo, useRef} from "react";
import Swal from "sweetalert2";
import {Row,Col,Button} from "reactstrap";
import axios from "axios";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { BiSave } from "react-icons/bi";
import { IoIosEye } from "react-icons/io";
import { TiCancel } from "react-icons/ti";
import { AiOutlineHome } from "react-icons/ai";
import { useCookies } from 'react-cookie';
import { default as ReactSelect } from "react-select";
import {useLocation,Link,useParams, useSearchParams} from 'react-router-dom';
import {displayErrorToast,parseBoolean,displayError} from '../../helpers';
import ErrorToast from '../../ErrorToast';
import FloatingControls from '../../components/FloatingControls';
import LoadingOverlay from '../../components/LoadingOverlay';
import { getCompanyDetails} from '../../services/CompanyServices';
import { getAllCustomerMain, getCustomerMainDetails} from '../../services/CustomerMainServices';
import { getCurrentDate, getCurrentTime} from '../../utils/DateUtils';
import { getHTMLForSummaryPopup } from '../../utils/PopupUtils';
import SummaryIcon from '../../components/SummaryIcon';
import QuestionIcon from '../../components/QuestionIcon';
import DmixIcon from '../../components/DmixIcon';
import ReactTablePopUpSubmitWrapper from "../../components/ReactTablePopUpSubmitWrapper";
import { getSalesOrderDetails, getSalesOrdersForWorkSchedule } from '../../services/SalesOrderServices';
import { getCustomerSiteDetails,getAllCustomerSites } from '../../services/CustomerSiteServices';
import { updateWorkSchedule,getWorkScheduleDetails,getWorkScheduleJobNumber,deleteWorkSchedule } from '../../services/WorkScheduleServices';
import ViewOnlyTextbox from '../../components/ViewOnlyTextbox';
import { getDisplayDate } from '../../utils/DateUtils';
import StatusDropDown from '../../components/StatusDropDown';
import { getDesignMixForWorkSchedule } from '../../services/DesignMixServices';
import { getAllPlantConfigurations } from '../../services/PlantConfigurationServices';
import { openDesignMixPopup } from '../dispatch/DeliveryChallanUtils';
import PremiumPageHeader from '../../components/PremiumPageHeader';
import { getReturnPath, navigateAfterFormSave } from '../../utils/returnNavigation';
import { formatQty } from '../../utils/listSummaryUtils';


function WorkScheduleEdit() {
    const initial_table_data = {
        total_pages: 0,
        records: [],
    };
    const [data, setData] = useState(initial_table_data);
    const [showModal, setShowModal] = useState(false);
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const returnTo = getReturnPath(location, searchParams);
    const returnToDeliveryChallan = Boolean(returnTo && returnTo.includes('DeliveryChallan'));
    const [cookies] = useCookies(['myToken']);
    const [category] = useCookies(['myCategory']);
    const [inProgress, setInProgress] = useState(false);
    const [superuser] = useCookies(['mySuperuser']);
    const [inputs, setInputs] = useState({});
    const [filteredplants,setFilteredPlants] = useState([]);
    const [products, setProducts] = React.useState([]);
    const [error, setError] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [salesorders,setSalesorders]=React.useState([]);
    const [selectedSalesOrder,setSelectedSalesOrder] = useState({});
    const [deliverymodes,setDeliveryModes] = useState([]);
    const [allSalesOrders,setAllSalesOrders] = useState([]);
    const [isModalLoading, setIsModalLoading] = useState(false);
    const [sites, setSites] = React.useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [isLoading, setIsLoading] = useState(true);  
    const [selectedCustomer,setSelectedCustomer]=React.useState({})
    const [selectedSite,setSelectedSite]= React.useState({})
    const [userId] = useCookies(['myUserId']);
    const [plantConfig,setPlantConfig] = React.useState([]);
    const [deliveryChallans, setDeliveryChallans] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [selectedCustomerOption, setSelectedCustomerOption] = useState(null);
    const salesOrderCacheRef = useRef({});
    const originalSoDetailIdRef = useRef(null);

    React.useEffect(() => {
      setInputs(values => ({...values,
          ['schedule_date']: getCurrentDate(), 
          ['delivery_date']: getCurrentDate(),
          ['delivery_time']: getCurrentTime(),
          ['is_extra_shut_required']:'false',
          ['cube_mould_test_place']:'plant',
          ['is_name_req']:'false'
      }))
    }, []);
 
    React.useEffect(() => {
      getAllCustomerMain(cookies)
        .then(customerList => {
          const options = (customerList.customer_list || [])
            .filter(cust => cust.status)
            .map(cust => ({ value: cust.id, label: cust.name }))
            .sort((a, b) => a.label.localeCompare(b.label));
          setCustomers(options);
        })
        .catch((error) => {
          displayError(error.response?.data ?? error.message, 'Failed to load customers');
        });
    }, []);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    try{
        setInputs(values => ({...values, [name]: value}));
        if(name === 'plant_id' && value){
            setIsLoading(true);
            getWorkScheduleJobNumber(cookies,value)
            .then(work_schedule => {
                setIsLoading(false);
                setInputs(values => ({...values, ['schedule_no']: work_schedule.schedule_no}));
            })
            .catch((error) =>
            {
                setIsLoading(false);
              console.log(error.response.data);
              displayError(error.response.data," Failed");
            })
        } else if (name === 'plant_id' && !value) {
            setInputs(values => ({...values, ['schedule_no']: ''}));
        }
        // else if (name === 'delivery_date')
        // {
        //     // Parse the delivery date string to a Date object
        //     var deliveryDate = new Date(value);
        //     console.log(deliveryDate+"deliveryDate");

        //     // Add 1 day to the delivery date
        //     var validityDate = new Date(deliveryDate);
        //     console.log(validityDate+"validityDate");
        //     validityDate.setDate(deliveryDate.getDate() + 1);

        //     // Format the validity date as YYYY-MM-DD
        //     console.log(validityDate.toISOString()+"validityDate.toISOString()")
        //     var formattedValidityDate = validityDate.toISOString().split('T')[0];
        //     console.log(formattedValidityDate+"formattedValidityDate");

        //     setInputs(values => ({...values, ['validity_date']: formattedValidityDate}));
        // }
    }
    catch (e) {
      displayErrorToast(e);
    }
  }

  const clearSalesOrderSelection = () => {
    setSelectedSalesOrder({});
    setSalesorders([]);
    setAllSalesOrders([]);
    setProducts([]);
    setDeliveryModes([]);
    setFilteredPlants([]);
    setData({ total_pages: 0, records: [] });
    setInputs(values => ({
      ...values,
      salesorder_id: '',
      sales_order_detail_id: '',
      plant_id: '',
      schedule_no: '',
      order_quantity: '',
      balance_qty: '',
      delivery_mode: '',
      validity_date: '',
    }));
  };

  const onCustomerSelect = (selected) => {
    if (inputs.is_schedule_completed) {
      return;
    }
    setSelectedCustomerOption(selected);
    const customerId = selected?.value || '';
    setInputs(values => ({...values, customer_id: customerId}));
    clearSalesOrderSelection();
  };
  
  const handleChangeSalesOrderDetails = (salesorderId) => {
    if (!salesorderId || inputs.is_schedule_completed) {
        setShowModal(false);
        return;
    }

    const selected_so = allSalesOrders.find(obj => obj.id == salesorderId);
    if (!selected_so) {
        setShowModal(false);
        return;
    }

    setSelectedSalesOrder(selected_so);
    setInputs(values => ({
        ...values,
        salesorder_id: salesorderId,
        sales_order_detail_id: '',
        validity_date: getDisplayDate(selected_so.validity_date),
    }));
    setProducts(selected_so.order_list
        .filter(order => order.product?.category?.name === 'FINISHED GOODS')
        .map(order => ({ value: order.id, label: order.product.name })));
    setDeliveryModes([]);

    getCompanyDetails(cookies, selected_so.company.id)
        .then(company => {
            setFilteredPlants(company.plants.map(plant => ({
                value: plant.id,
                label: plant.alias,
            })));
        })
        .catch((error) => {
            displayError(error.response?.data ?? error.message, 'Failed to load company plants');
        });

    setShowModal(false);
  } 
 
  const handleChangeProductDetails = (event) =>{
    const DM_MANUAL = 'manual';
    const DM_PUMP = 'pump';
    const DM_MANUAL_OR_PUMP = 'manual/pump';

    const sales_order_detail_id = event.target.value;
    const propertyName = event.target.name;
    
    if (sales_order_detail_id) {
        let selected_product = selectedSalesOrder.order_list.filter( order => order.id == sales_order_detail_id)[0];
        let balanceQty = Number(selected_product.balance_qty);
        if (!Number.isFinite(balanceQty)) {
            balanceQty = Number(selected_product.quantity || 0) - Number(selected_product.scheduled_qty || 0);
        }
        if (String(sales_order_detail_id) === String(originalSoDetailIdRef.current)) {
            balanceQty += Number(inputs.scheduled_qty || 0);
        }
        balanceQty = Math.round(balanceQty * 100) / 100;
        setInputs(values =>({...values,
            [propertyName]:sales_order_detail_id,
            ['delivery_mode']:(selected_product.delivery_mode === DM_MANUAL_OR_PUMP ? '' : selected_product.delivery_mode),
            ['order_quantity']:selected_product.quantity,
            ['balance_qty']:balanceQty
        }));
        document.getElementById('scheduled_qty').max = Math.max(0, balanceQty);
console.log(selected_product.delivery_mode,"selected_product.delivery_mode")
        if (selected_product.delivery_mode === 'manual/pump') {
            setDeliveryModes([
                {value: '' ,label:'Please select Delivery Mode'},
                {value: DM_MANUAL ,label:DM_MANUAL.toUpperCase()},
                {value: DM_PUMP ,label:DM_PUMP.toUpperCase()}
            ])
        } else {
            setDeliveryModes([{value: selected_product.delivery_mode ,label:selected_product.delivery_mode.toUpperCase()}])
        }
    }
   } 
   
      const navigate = useNavigate();
      const handleChangeCementDisplyed = (event) =>{
        const name = event.target.name;
        const value = event.target.value;
        const FIELD_CEMENT_NAME='cement_name';
        if(value === 'false'){
           document.getElementById(FIELD_CEMENT_NAME).disabled = true;
           document.getElementById(FIELD_CEMENT_NAME).required = false;
           document.getElementById(FIELD_CEMENT_NAME).className = document.getElementById(FIELD_CEMENT_NAME).className.replace('mandatory-form-control',''); 
        }
        else
        {
            document.getElementById(FIELD_CEMENT_NAME).disabled = false;
            document.getElementById(FIELD_CEMENT_NAME).required = true;
            document.getElementById(FIELD_CEMENT_NAME).className += ' mandatory-form-control'; 
        }
        setInputs(values => ({...values, [name]: event.target.value}))
    }

  const showCustomerDetails = () => {
        if (selectedSalesOrder.id) {
            getCustomerMainDetails(cookies,selectedSalesOrder.consignee.customer.id)
            .then(selectedCustomer => {
                Swal.fire({
                    html:getHTMLForSummaryPopup(
                        'BILLING DETAILS',
                        [
                        {label: 'ADDRESS', value: selectedCustomer.address_1},
                        {value: selectedCustomer.address_2},
                        {value: selectedCustomer.address_3},
                        {label: 'GST', value: selectedCustomer.gst_no},
                        {label: 'PAN', value: selectedCustomer.pan_no},
                        {label: 'SALES OFFICER', value: selectedCustomer.salesrep.name},
                        {label: 'CREDIT LIMIT', value: selectedCustomer.credit_limit}
                        ])
                }, '', 'info');
            })
        }
   }

   const showSiteDetails = () => {
    if (selectedSalesOrder.id) {
        getCustomerSiteDetails(cookies,selectedSalesOrder.consignee.id)
        .then(consignee => {
            Swal.fire({
                html:getHTMLForSummaryPopup(
                    'SITE DETAILS',
                    [
                    {label: 'ADDRESS', value: consignee.address_1},
                    {value: consignee.address_2},
                    {value: consignee.address_3},
                    {label: 'SITE NAME', value: consignee.name},
                    {label: 'CONTACT NAME', value: consignee.contact_person},
                    {label: 'MOBILE NO', value: consignee.contact_mobile_no},
                    {label: 'DESIGNATION', value: consignee.contact_designation}
                    ])
            }, '', 'info');   
        })
          
    }
    
}
const showSalesOrderDetails = () => {
    if (selectedSalesOrder.id) {
            Swal.fire({
                html:getHTMLForSummaryPopup(
                    'SALESORDER DETAILS',
                    [
                    {label: 'SO DATE', value: selectedSalesOrder.order_date},
                    {label: 'MODE OF TRANSPORT', value: selectedSalesOrder.transport_mode},
                    {label: 'DELIVERY DATE', value: selectedSalesOrder.delivery_date},
                    {label: 'REMARKS', value: selectedSalesOrder.user_remarks}
                   
                    ])
            }, '', 'info');   
    }
    
}
const onDeleteWorkSchedule = (event) => {
    event.preventDefault();
    Swal.fire({title: 'Are you sure to Delete?',  
    showCancelButton: true,  
    confirmButtonText: `Yes`,  
    cancelButtonText: `No`,
    }).then((result) => {  
      if (result.isConfirmed) { 

        setIsLoading(true);
        deleteWorkSchedule(cookies, id)
        .then(response => {
            console.log(`Work schedule with id ${id} deleted`);
            setRefreshKey(oldKey => oldKey +1);
            Swal.fire('Deleted Successfully!', '', 'success');
            view();
        })
        .catch(error => {
            setRefreshKey(oldKey => oldKey +1);
            console.log(error.response.data);
            displayError(error.response.data,'Delete Failed');
        }); 
        
        
      } else if (result.isDismissed) {    
        Swal.fire('Not Deleted', '', 'info')  
    }
    });
    //

};

const constructFormData = () => {
    const EMPTY_STRING = '';
    return {
        id :id,
        plant_id:parseInt(inputs.plant_id) ,
        sales_order_detail_id:parseInt(inputs.sales_order_detail_id),
        schedule_no: inputs.schedule_no,
        schedule_date:getDisplayDate(inputs.schedule_date),
        is_name_req:parseBoolean(inputs.is_name_req),
        cement_name: inputs.cement_name,
        delivery_date:getDisplayDate(inputs.delivery_date),
        validity_date:getDisplayDate(inputs.validity_date),
        delivery_time:inputs.delivery_time,
        scheduled_qty:parseFloat(inputs.scheduled_qty),
        is_extra_shut_required:parseBoolean(inputs.is_extra_shut_required),
        delivery_mode: inputs.delivery_mode,
        slump1: parseInt(inputs.slump1),
        slump2: parseInt(inputs.slump2),
        cube_mould_test_place: inputs.cube_mould_test_place,
        status:inputs.status
    }
} 
 
const showDesignMixTable = () =>{
  if (inputs.id) {
    getDesignMixForWorkSchedule(cookies,inputs.id)
    .then(designmix_list => {
        openDesignMixPopup({
          cookies,
          designmix_list,
          plantConfig,
          plantId: inputs.plant_id,
        });
    })
  }
}
 
   //If all the required fields are field u can select the save button then choose the option yes or no
   const handleSubmit = (event) => {
    event.preventDefault();
   
    if ((Object.values(error).every(x => !x)) && isSubmitting) { 
        Swal.fire({title: 'Do you want to Update?',  
          showCancelButton: true,  
          confirmButtonText: `Yes`,  
          cancelButtonText: `No`,
          }).then((result) => {  
            if (result.isConfirmed) 
            { 
               
              updateWorkSchedule(cookies, constructFormData(),id)
              .then(function (response) {
                Swal.fire('Updated!', '', 'success') 
                view();
              })
              .catch((error) =>
              {
                console.log(error.response.data);
                displayError(error.response.data,"Update Failed");
              })
              
            } 
            else if (result.isDismissed) 
            {    
              Swal.fire('Not Updated', '', 'info')  
            }
          });
    }
    else
    {
      Swal.fire('Please check * marked fields are filled and details given are valid...', '', 'info')   
    }
}
const {id}=useParams()
const FIELD_CEMENT_NAME='cement_name';

React.useEffect(() => {
  if (id) {
    setInProgress(true);
    getWorkScheduleDetails(cookies, id)
      .then(workschedule_object => {
        setInProgress(false);
        setDeliveryChallans(workschedule_object.delivery_challans || []);
        const salesOrder = workschedule_object.sales_order_detail.sales_order;
        const customerId = salesOrder?.consignee?.customer?.id;
        const customerName = salesOrder?.consignee?.customer?.name || '';
        if (customerId) {
            const customerOption = { value: customerId, label: customerName };
            setSelectedCustomerOption(customerOption);
            setCustomers(prev => {
                if (prev.some(option => String(option.value) === String(customerId))) {
                    return prev;
                }
                return [...prev, customerOption].sort((a, b) => a.label.localeCompare(b.label));
            });
        }
        setSalesorders([{
            value: salesOrder.id,
            label: `${salesOrder.prefix || ''}${salesOrder.order_no || ''}`,
        }]);
        originalSoDetailIdRef.current = workschedule_object.sales_order_detail.id;
        setInputs({...workschedule_object, 
            id:workschedule_object.id,
            customer_id: customerId || '',
            salesorder_id:workschedule_object.sales_order_detail.sales_order.id,
            plant_id:workschedule_object.plant.id,
            sales_order_detail_id:workschedule_object.sales_order_detail.id,
            delivery_mode:workschedule_object.delivery_mode,
            schedule_no:parseInt(workschedule_object.schedule_no),
            schedule_date:getDisplayDate(workschedule_object.schedule_date),
            is_name_req:parseBoolean(workschedule_object.is_name_req),
            is_designmix_prepared:parseBoolean(workschedule_object.is_designmix_prepared),
            cement_name: workschedule_object.cement_name,
            delivery_date:getDisplayDate(workschedule_object.delivery_date),
            delivery_time:workschedule_object.delivery_time,
            scheduled_qty:parseInt(workschedule_object.scheduled_qty),
            is_extra_shut_required:parseBoolean(workschedule_object.is_extra_shut_required),
            delivery_mode: workschedule_object.delivery_mode,
            slump1: parseInt(workschedule_object.slump1),
            slump2: parseInt(workschedule_object.slump2),
            cube_mould_test_place: workschedule_object.cube_mould_test_place,
            is_schedule_completed:workschedule_object.is_schedule_completed,
            validity_date: getDisplayDate(workschedule_object.validity_date),
            status:String(workschedule_object.status)
            });

            getCompanyDetails(cookies,workschedule_object.sales_order_detail.sales_order.company.id)  //get plant list
            .then(company =>{
                setFilteredPlants(company.plants.map( plant =>{
                    return {value: plant.id,label : plant.alias}
                }));
            })

            getAllPlantConfigurations(cookies,workschedule_object.plant.id)
            .then (
                plantConfigList => {
                  setPlantConfig(plantConfigList);
                }
            )
            if (workschedule_object.sales_order_detail.delivery_mode == 'manual/pump'){
              setDeliveryModes([
                {value: '' ,label:'Please select delivery mode'},
                {value: 'manual' ,label:'MANUAL'},
                {value:'pump',label:'PUMP'},
              ])
            }
            else{
              setDeliveryModes([{value: workschedule_object.delivery_mode ,label:workschedule_object.delivery_mode.toUpperCase()}])
            }
          getCustomerMainDetails(cookies,workschedule_object.sales_order_detail.sales_order.consignee.customer.id)    
          .then(customerObject => {              //Set the details of the customer in the form fields
              setSelectedCustomer(customerObject)
              })
  
          getCustomerSiteDetails(cookies,workschedule_object.sales_order_detail.sales_order.consignee.id)
                .then(customerObject => {                     //Set the details of the customer in the form fields
                    setSelectedSite(customerObject);
                });

        getSalesOrderDetails(cookies,workschedule_object.sales_order_detail.sales_order.id)
          .then(salesorderObject =>{
            setSelectedSalesOrder(salesorderObject)
            setProducts(salesorderObject.order_list  
                .filter(order => order.product.category.name === 'FINISHED GOODS')
                .map(order => ({value : order.id,label : order.product.name})));
            
                let selected_product = salesorderObject.order_list  
                .filter(order => order.id === workschedule_object.sales_order_detail.id)[0];
                
              let balanceQty = (selected_product.balance_qty)+(workschedule_object.scheduled_qty)
              // selected_product.quantity-workschedule_object.delivered_qty-workschedule_object.scheduled_qty
        setInputs(values =>({...values,
           
            ['order_quantity']:selected_product.quantity,
            ['balance_qty']:balanceQty
        }));
        document.getElementById('scheduled_qty').max = balanceQty;    
          })
          if(workschedule_object.is_name_req){
            document.getElementById(FIELD_CEMENT_NAME).disabled = false;
            document.getElementById(FIELD_CEMENT_NAME).required = true;
          }
          else{
            document.getElementById(FIELD_CEMENT_NAME).disabled = true;
            document.getElementById(FIELD_CEMENT_NAME).required = false;
          }
      }).catch(error => {
        setInProgress(false);
        displayError(error.response.data, "Loading Failed");
      });
    }
  }, []);
  
    const Reload = () => {
        window.location.reload();
      }      

      const view = () => {
        navigateAfterFormSave(navigate, location, '/WorkScheduleTable', searchParams);
      }

      const handlePrint = (event) => {
        event.preventDefault();
        if (!id) {
          return;
        }
        navigate(`/JobCompletionReport/${id}/`);
      };  
        const Back = () => {
          if (returnTo) {
            navigate(returnTo, { replace: true });
            return;
          }
          navigate('/Home')
        }
        const Cancel = () => {
            setInputs(() => "")
             navigate(location.pathname, { replace: true });
        }

    const applySalesOrderPickerData = (activeSalesOrders) => {
        const salesorderOptions = activeSalesOrders.map(salesorder => ({
            value: salesorder.id,
            label: salesorder.prefix + salesorder.order_no,
        }));
        setSalesorders(salesorderOptions);
        setAllSalesOrders(activeSalesOrders);

        const tableData = activeSalesOrders.map(salesorder => {
            const availableLines = salesorder.order_list || [];
            const gradeNames = [...new Set(
                availableLines.map(line => line.product?.name).filter(Boolean)
            )].join(', ');
            const deliveryModes = [...new Set(
                availableLines.map(line => (line.delivery_mode || '').toUpperCase()).filter(Boolean)
            )].join(', ');
            const lineOrderQty = availableLines.reduce((sum, line) => sum + (Number(line.quantity) || 0), 0);
            const lineBalanceQty = availableLines.reduce((sum, line) => sum + (Number(line.balance_qty) || 0), 0);

            return {
                id: salesorder.id,
                order_no: `${salesorder.prefix || ''}${salesorder.order_no || ''}`,
                order_date: salesorder.order_date,
                grade: gradeNames || salesorder.grades || '',
                delivery_mode: deliveryModes || salesorder.delivery_modes || '',
                order_qty: formatQty(salesorder.order_qty ?? lineOrderQty),
                balance_qty: formatQty(salesorder.balance_qty ?? lineBalanceQty),
                customer_name: salesorder.consignee?.customer?.name ?? '',
                consignee_name: salesorder.consignee?.project_name ?? '',
                company: salesorder.company?.name ?? '',
                prefix: salesorder.prefix,
                validity_date: salesorder.validity_date,
            };
        });

        setData({
            total: tableData.length,
            records: tableData,
        });

        if (tableData.length === 0) {
            setShowModal(false);
            Swal.fire('No sales orders available for work schedule.', '', 'info');
            return;
        }
        setShowModal(true);
    };

    const Help = () => {
        if (inputs.is_schedule_completed) {
            Swal.fire('Completed work schedules cannot change the sales order.', '', 'info');
            return;
        }
        if (!inputs.customer_id) {
            Swal.fire('Please select a Customer first.', '', 'warning');
            return;
        }

        setShowModal(true);
        const cachedOrders = salesOrderCacheRef.current[inputs.customer_id];
        if (cachedOrders) {
            setIsModalLoading(false);
            applySalesOrderPickerData(cachedOrders);
            return;
        }

        setIsModalLoading(true);
        getSalesOrdersForWorkSchedule(cookies, inputs.customer_id)
            .then(salesorderList => {
                const activeSalesOrders = (salesorderList?.sales_order_list || []).filter(obj => obj.status);
                salesOrderCacheRef.current[inputs.customer_id] = activeSalesOrders;
                setIsModalLoading(false);
                applySalesOrderPickerData(activeSalesOrders);
            })
            .catch((error) => {
                setIsModalLoading(false);
                setShowModal(false);
                displayError(error.response?.data ?? error.message, 'Failed to load sales orders');
            });
    };

    const Close = () => {
        setShowModal(false);
    };

    const columns = useMemo(
        () => [
            {
                fieldName: "id",
                headerName: "ROW_ACTIONS",
                size: 56,
            },
            {
                fieldName: 'order_no',
                headerName: 'SO No',
                size: 140,
            },
            {
                fieldName: 'order_date',
                headerName: 'SO Date',
                size: 110,
            },
            {
                fieldName: 'validity_date',
                headerName: 'Validity Date',
                size: 120,
            },
            {
                fieldName: 'grade',
                headerName: 'Grade',
                size: 110,
            },
            {
                fieldName: 'order_qty',
                headerName: 'SO Qty',
                size: 90,
                align: 'right',
            },
            {
                fieldName: 'balance_qty',
                headerName: 'Balance Qty',
                size: 110,
                align: 'right',
            },
            {
                fieldName: 'delivery_mode',
                headerName: 'Mode Of Delivery',
                size: 140,
            },
            {
                fieldName: "customer_name",
                headerName: 'Customer',
                size: 180,
            },
            {
                fieldName: "consignee_name",
                headerName: 'Site',
                size: 160,
            },
        ],
        [],
    );

    return (
    <>
     <div id="outer-container" className="App">
        <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
        <ErrorToast/>
        <LoadingOverlay inProgress={inProgress}/>
        <div id="page-wrap">
        <form onSubmit={handleSubmit}>
          <div className="premium-page-header-wrap">
          <PremiumPageHeader
              module="PLANNING"
              title="Update Work Schedule"
              subtitle="Edit work schedule quantities, timing, and site details."
              modeLabel="EDIT MODE"
            />
          </div>
          <FloatingControls tableLink="/WorkScheduleTable" enableCancel={false}/>
          <div className="form-content-wrap">
                    <div className="form-row table-bordered shadow p-2 my-2 border-secondary form-control-panel">
                    <h5 className='col-sm-11'><b>Order Details</b></h5><br/><br/>
                    {showModal && (
                        <div className="so-picker-overlay" onClick={Close}>
                            <div
                                className="modal-dialog modal-xl so-picker-modal-dialog"
                                onClick={(event) => event.stopPropagation()}
                            >
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <div className="container item-list-table-container so-picker-table-wrap">
                                            <ReactTablePopUpSubmitWrapper
                                                title='Select Sales Order'
                                                columns={columns}
                                                data={data.records}
                                                onRowSubmit={handleChangeSalesOrderDetails}
                                                isLoading={isModalLoading}
                                                onClose={Close}
                                                initialPageSize={15}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <Row className="form-equal-height-row no-gutters">
                    <Col xl={6} lg={6} md={12}>
                    <div className="form-row p-2 my-2 border-secondary form-control-panel form-panel-fill">
                    <label htmlFor="customer_id" className="form-group col-sm-4 text-right">Customer</label>
                    <div className="col-sm-7 px-0 ws-customer-select">
                        <ReactSelect
                            id="customer_id"
                            options={customers}
                            isSearchable={true}
                            isClearable={!inputs.is_schedule_completed}
                            value={selectedCustomerOption}
                            onChange={onCustomerSelect}
                            placeholder="Type to select..."
                            className="mandatory-form-control"
                            isDisabled={Boolean(inputs.is_schedule_completed)}
                            title={selectedCustomerOption?.label || ''}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            menuPosition="fixed"
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({ ...base, minHeight: 31, width: '100%' }),
                              valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                              singleValue: (base) => ({ ...base, maxWidth: 'calc(100% - 8px)' }),
                            }}
                        />
                    </div>
                    <ViewOnlyTextbox
                        name="purchase_order_no"
                        value={selectedSalesOrder?.purchase_order_no || ""}
                        labelClassName="form-group col-sm-4 text-right"
                        label="Purchase Order No"
                        inputClassName="form-control col-sm-7"
                    />
                    <ViewOnlyTextbox
                        name="order_date"
                        value={selectedSalesOrder?.order_date || ""}
                        labelClassName="form-group col-sm-4 text-right"
                        label="Order Date"
                        inputClassName="form-control col-sm-7"
                    />
                    </div>
                    </Col>
                    <Col xl={6} lg={6} md={12}>
                    <div className="form-row p-2 my-2 border-secondary form-control-panel form-panel-fill">
                    <label htmlFor="salesorder_id" className="form-group col-sm-4 text-right">Sales Order</label>
                    <div className="col-sm-7 px-0 form-input-with-icon">
                        <select id="salesorder_id" name="salesorder_id" className="form-control" value={inputs.salesorder_id || ""} disabled={true}>
                        <option value=""></option>
                            {salesorders.map((item) => (
                                <option key={item.value} value={item.value}>
                                    {item.label}</option>
                            ))}
                        </select>
                        {!inputs.is_schedule_completed && (
                            <QuestionIcon onClickHandler={Help}/>
                        )}
                        <SummaryIcon onClickHandler={showSalesOrderDetails}/>
                    </div>
                    <label htmlFor="billing_name" className="form-group col-sm-4 text-right">Billing Name</label>
                    <div className="col-sm-7 px-0 form-input-with-icon">
                    <ViewOnlyTextbox
                        name="billing_name"
                        value={selectedSalesOrder?.consignee?.customer?.name || ""}
                        inputClassName="form-control"
                        showSummaryDetails={showCustomerDetails}
                    />
                    </div>
                    <label htmlFor="ship_to" className="form-group col-sm-4 text-right">Ship To</label>
                    <div className="col-sm-7 px-0 form-input-with-icon">
                    <ViewOnlyTextbox
                        name="ship_to"
                        value={selectedSalesOrder?.consignee?.project_name|| ""}
                        inputClassName="form-control"
                        showSummaryDetails={showSiteDetails}
                    />
                    </div>
                    </div>
                    </Col>
                    </Row>
                    </div>
            <h5 style={{paddingTop:"12px"}}><b>SCHEDULE DETAILS </b>
            {((inputs.is_designmix_prepared) &&
              <DmixIcon onClickHandler={showDesignMixTable}/>
            )}
            </h5>
            <Row className="form-equal-height-row no-gutters">
                <Col xl={6} lg={12} md={12}>
                   <div className="form-row table-bordered shadow p-2 my-2 border-secondary form-control-panel form-panel-fill">
                        <label htmlFor="plant_id" className="form-group col-sm-4 text-right">Plant Location</label>
                        <select id="plant_id" name="plant_id" className="form-control col-sm-7 browser-default custom-select mandatory-form-control" required onChange={handleChange} value={inputs.plant_id || ""}>
                        <option value="">Select plant</option>
                            {filteredplants.map((item) => (
                                <option key={item.value} value={item.value}>
                                    {item.label}</option>
                            ))}
                    </select>
                        <label htmlFor="sales_order_detail_id" className="form-group col-sm-4 text-right">Grade</label>
                        <select id="sales_order_detail_id" name="sales_order_detail_id" className="form-control col-sm-7 browser-default custom-select mandatory-form-control" required onChange={handleChangeProductDetails} value={inputs.sales_order_detail_id || ""}>
                        <option value="">Select Products</option>
                            {products.map((item) => (
                                <option key={item.value} value={item.value}>
                                    {item.label}</option>
                            ))}
                        </select>
                        <label htmlFor="delivery_mode" className="form-group col-sm-4 text-right">Mode of Delivery</label>
                        <select className="form-control col-sm-7 browser-default custom-select mandatory-form-control" required onChange={handleChange} value={inputs.delivery_mode || ""} name="delivery_mode" id="delivery_mode">
                        {deliverymodes.map((item) => (
                                <option key={item.value} value={item.value}>
                                    {item.label}</option>
                                      ))}
                        </select>
                        <label htmlFor="delivery_date" className="form-group col-sm-4 text-right">Delivery Date & Time</label>
                        <div className="form-datetime-pair col-sm-7">
                            <input type="date" id="delivery_date" required name="delivery_date" onChange={handleChange} value={inputs.delivery_date || ""} className="form-control mandatory-form-control"/>
                            <input type="time" id="delivery_time" name="delivery_time" required onChange={handleChange} value={inputs.delivery_time || ""} className="form-control mandatory-form-control"/>
                        </div>
                        <label htmlFor="scheduled_qty" className="form-group col-sm-4 text-right">Schedule Qty</label>
                        <input type="number" id="scheduled_qty" step="any" onChange={handleChange} value={inputs.scheduled_qty || ''} className="form-control col-sm-7 mandatory-form-control" required name="scheduled_qty"/>
                        <label htmlFor="is_extra_shut_required" className="form-group col-sm-4 text-right">Is Extra Chute Required?</label>
                    <select className="form-control col-sm-7 browser-default custom-select" required onChange={handleChange} value={inputs.is_extra_shut_required || ""} name="is_extra_shut_required" id="is_extra_shut_required">
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                    </select>
                    <label htmlFor="cube_mould_test_place" className="form-group col-sm-4 text-right">Cube Mould Test @</label>
                    <select id="cube_mould_test_place" className="form-control col-sm-7 browser-default custom-select" onChange={handleChange} value={inputs.cube_mould_test_place || ""} name="cube_mould_test_place">
                        <option value="plant">Plant</option>
                        <option value="site">Site</option>
                        <option value="plant_and_site">Plant and Site</option>
                    </select>
                    <label htmlFor="slump1" className="form-group col-sm-4 text-right">Slump @ Plant / Site</label>
                    <div className="form-datetime-pair col-sm-7">
                        <input type="number" name="slump1" onChange={handleChange} value={inputs.slump1 || 0} className="form-control" />
                        <input type="number" name="slump2" onChange={handleChange} value={inputs.slump2 || 0} className="form-control" />
                    </div>
                      <label htmlFor="is_name_req" className="form-group col-sm-4 text-right">Is Cement name to be displayed in DC?</label>
                        <select className="form-control col-sm-7 browser-default custom-select" id="is_name_req" onChange={handleChangeCementDisplyed} value={inputs.is_name_req || 'false'} required name="is_name_req">
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                        </select>
                       <label htmlFor="cement_name" className="form-group col-sm-4 text-right">Cement Name</label>
                        <input type="text" className="form-control col-sm-7" onChange={handleChange} value={inputs.cement_name || ""} id="cement_name" name="cement_name" disabled={true} />
                    </div>
                </Col>
                <Col xl={6} lg={12} md={12}>
                <div className="form-row table-bordered shadow p-2 my-2 border-secondary form-control-panel form-panel-fill">
                        <label htmlFor="schedule_no" className="form-group col-sm-4 text-right">Job No</label>
                        <input type="text" className="form-control col-sm-7" id="schedule_no" value={inputs.schedule_no || ""} readOnly={true} style={{cursor: "not-allowed"}} name="schedule_no" disabled={true}/>
                        <label htmlFor="schedule_date" className="form-group col-sm-4 text-right">Job Date</label>
                        <input type="date" className="form-control col-sm-7 mandatory-form-control" id="schedule_date" value={inputs.schedule_date || getCurrentDate()} name="schedule_date" required onChange={handleChange} />
                        <label htmlFor="order_quantity" className="form-group col-sm-4 text-right">Order Qty.</label>
                        <input type="number" className="form-control col-sm-7" readOnly={true} style={{ cursor: "not-allowed"}} name="order_quantity" disabled={true} value={inputs.order_quantity || ""} />
                        <label htmlFor="balance_qty" className="form-group col-sm-4 text-right">Balance Qty.</label>
                        <input type="number" value={inputs.balance_qty || ""} name="balance_qty" id="balance_qty" readOnly={true} className="form-control col-sm-7" disabled={true} style={{ cursor: "not-allowed"}}/>
                        <label htmlFor="validity_date" className="form-group col-sm-4 text-right">Validity Date</label>
                        <input type="date" id="validity_date" name="validity_date" value={inputs.validity_date || ""} className="form-control col-sm-7" onChange={handleChange} />
                        <StatusDropDown status={inputs.status} onChange={handleChange}/>
                </div>
                </Col>
            </Row>
                <div className="table-responsive" style={{ marginTop: '16px', marginBottom: '8px' }}>
                        <h5><b>Delivery Challan Details</b></h5>
                        <table className="table table-bordered table-sm" style={{ textAlign: 'center', backgroundColor: '#fff', marginBottom: 0 }}>
                            <thead>
                                <tr style={{ backgroundColor: '#1e3a8a', color: '#fff' }}>
                                    <th>DC No</th>
                                    <th>DC Date</th>
                                    <th>DC Time</th>
                                    <th>Vehicle No</th>
                                    <th>DC Qty</th>
                                    <th>Accepted Qty</th>
                                    <th>Customer Status</th>
                                    <th>DC Status</th>
                                    <th>Record Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {deliveryChallans.length === 0 ? (
                                    <tr>
                                        <td colSpan={9} style={{ padding: '12px', color: '#64748b' }}>
                                            No delivery challans for this schedule.
                                        </td>
                                    </tr>
                                ) : (
                                    deliveryChallans.map((item) => (
                                        <tr key={item.id} style={{ backgroundColor: item.status === 'Cancelled' ? '#f8d7da' : undefined }}>
                                            <td>{item.dc_no}</td>
                                            <td>{item.dc_date}</td>
                                            <td>{item.dc_time}</td>
                                            <td>{item.vehicle_no || '-'}</td>
                                            <td>{item.dc_qty}</td>
                                            <td>{item.accepted_qty}</td>
                                            <td>{item.customer_status || '-'}</td>
                                            <td>{item.cus_dc_status || '-'}</td>
                                            <td>{item.status}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                            {deliveryChallans.length > 0 ? (
                                <tfoot>
                                    <tr style={{ fontWeight: 'bold', backgroundColor: '#eef2ff' }}>
                                        <td colSpan={4} style={{ textAlign: 'right' }}>Total</td>
                                        <td>
                                            {deliveryChallans.reduce((sum, row) => sum + (Number(row.dc_qty) || 0), 0)}
                                        </td>
                                        <td>
                                            {deliveryChallans.reduce((sum, row) => sum + (Number(row.accepted_qty) || 0), 0)}
                                        </td>
                                        <td colSpan={3}></td>
                                    </tr>
                                </tfoot>
                            ) : null}
                        </table>
                    </div>
            </div>
                <div className="footer text-center">
                <Button type="submit" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} >Update</Button> &nbsp;&nbsp;
                {inputs.is_schedule_completed ? (
                    <>
                    <Button type="button" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} onClick={handlePrint}>Print</Button>&nbsp;&nbsp;
                    </>
                ) : null}
                <Button className="btn btn-twitter" type="button" style={{width: returnToDeliveryChallan ? '180px' : '80px',fontWeight:"bold"}} onClick={view}>{returnToDeliveryChallan ? 'Back to DC' : 'View'}</Button>&nbsp;&nbsp;
                <Button className="btn btn-twitter" type="button" style={{width:"80px",fontWeight:"bold"}} onClick={Back}>{returnTo ? 'Back' : 'Home'}</Button>&nbsp;&nbsp;
                {!inputs.is_schedule_completed &&
                  (<><Button className="btn btn-delete" type="button" style={{width:"80px",fontWeight:"bold"}} onClick={onDeleteWorkSchedule}>Delete</Button></>)
                }
                </div>
        </form>
        </div>
    </div>
         </>
    );
  }
  export default WorkScheduleEdit;